import { Body2 } from 'stories/elements/Typography/Text'
import Breadcrumbs from 'components/modules/SEO/Breadcrumbs'
import styled from 'styled-components'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import { knowledgeAreaRoute, knowledgeDomainRoute, knowledgeItemRoute } from 'lib/constants/routes'

const Container = styled.div`
    max-width: 1024px;
`

const EmptyBreadcrumbsContainer = styled(Body2)`
    padding-bottom: 10px;

    @media (max-width: 750px) {
        padding: 5px 0 0 5px;
    }
`

interface Props {
    knowSeoInfo: KnowSeoInfo | null
    referrerScreen?: string
}

const KnowBreadcrumbs = ({ knowSeoInfo, referrerScreen }: Props) => {
    if (!knowSeoInfo) return null

    const { knowledgeArea } = knowSeoInfo

    const parts: { label: string; href: string; isNotALink?: true }[] = []

    // Use knowledgeArea structure
    if (knowledgeArea?.slug && knowledgeArea?.name) {
        // Add Knowledge Area breadcrumb
        parts.push({
            label: knowledgeArea.name,
            href: knowledgeAreaRoute(knowledgeArea.slug),
        })

        // Add Knowledge Domain breadcrumb if available
        if (knowledgeArea.knowledgeDomain?.slug && knowledgeArea.knowledgeDomain?.name) {
            parts.push({
                label: knowledgeArea.knowledgeDomain.name,
                href: knowledgeDomainRoute(knowledgeArea.slug, knowledgeArea.knowledgeDomain.slug),
            })

            // Add Knowledge Item breadcrumb if available
            if (knowledgeArea.knowledgeDomain.knowledgeItem?.slug && knowledgeArea.knowledgeDomain.knowledgeItem?.name) {
                parts.push({
                    label: knowledgeArea.knowledgeDomain.knowledgeItem.name,
                    href: knowledgeItemRoute(
                        knowledgeArea.slug,
                        knowledgeArea.knowledgeDomain.slug,
                        knowledgeArea.knowledgeDomain.knowledgeItem.slug
                    ),
                })
            }
        }
    }

    // Add the current Know title as the final breadcrumb (not a link)
    if (knowSeoInfo.title) {
        parts.push({
            label: knowSeoInfo.title,
            href: '',
            isNotALink: true,
        })
    }

    const showBreadcrumbs = !!knowSeoInfo && parts.length > 0

    return (
        <Container>
            {showBreadcrumbs ? (
                <Breadcrumbs breadcrumbs={parts} know={knowSeoInfo.know} referrerScreen={referrerScreen} />
            ) : (
                <EmptyBreadcrumbsContainer />
            )}
        </Container>
    )
}

export default KnowBreadcrumbs
